import { makeAutoObservable } from 'mobx';

import { AssistantStore } from './assistant/AssistantStore';
import { CommonStore } from './common/CommonStore';
import { CopyFormStore } from './copyForm/CopyFormStore';
import { CopyTradingStore } from './copyTrading/CopyTradingStore';
import { GalaxyStore } from './galaxy/GalaxyStore';
import { PortfolioStore } from './portfolio/PortfolioStore';
import { SwapStore } from './swap/SwapStore';
import { Web3Store } from './web3/Web3Store';

class Store {
  web3Store = new Web3Store();
  commonStore = new CommonStore(this.web3Store);
  swapStore = new SwapStore(this.web3Store, this.commonStore);
  copyTradingStore = new CopyTradingStore(this.web3Store, this.commonStore);
  copyFormStore = new CopyFormStore(this.web3Store, this.commonStore);
  assistantStore = new AssistantStore();
  galaxyStore = new GalaxyStore(this.web3Store, this.commonStore, this.assistantStore);
  portfolioStore = new PortfolioStore(this.web3Store, this.commonStore);

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get web3() {
    return this.web3Store;
  }
}

export const store = new Store();
